module.exports = __webpack_public_path__ + "img/A13b_20030051-007.1 and -008.1_verso.4eda1ba4.jpg";